import { INVOICES_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: INVOICES_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkInvoices'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/invoices/index.js